<template>
  <div v-if="detailsData" class="time-off-report-details">
    <FullscreenTabs hideFullscreen>
      <template v-slot:tabsControls>
        <div class="table-tab-list">
          <div class="d-flex" v-for="tab in tabs" :key="tab.key">
              <button class="table-tab-item" :class="tab.key === currentTab.key ? 'active' : ''" :data-text="tab.name" @click="setCurrentTab(tab)">{{ tab.name }}</button>
              <span class="table-tab-item_gap"></span>
          </div>
          <div class="table-tab-item"></div>
        </div>
      </template>

      <template v-slot:tabsControlsRight>
        <b-button v-show="currentTab.key === 'adjustments_history'" @click="$emit('showAdjustModal', userId)" variant="success" class="button add-adjustments-btn">
          Add adjustments
        </b-button>
      </template>

      <template v-slot:tabsContent>
        <div class="pl-2 pb-2" v-show="currentTab.key === 'adjustments_history'">
          <div v-if="Object.keys(detailsData.adjustments).length">
              <div :key="field + userId + 'adjustments'" class="mt-3" v-for="field in Object.keys(detailsData.adjustments)">
                <div class="sub-title">{{ field.replaceAll('_', ' ') }}</div>
                <NestedTable :items="detailsData.adjustments[field]" :fields="adjustmentsCols"
                  :slots="adjustmentsSlots">
                  <template v-slot:updated_at="slotProps">
                    <div>{{ moment(slotProps.item.updated_at).format('DD/MM/YYYY') }}</div>
                  </template>

                  <template v-slot:adjust="slotProps">
                    <div :style="`color: ${slotProps.item.adjust < 0 ? '#DC3545' : '#3FA52F'}`">
                      {{ slotProps.item.adjust > 0 ? `+${slotProps.item.adjust}` : slotProps.item.adjust }}
                    </div>
                  </template>
                </NestedTable>
              </div>
          </div>
          <div v-else class="p-3">No data</div>
        </div>

        <div class="pl-2 pb-2" v-show="currentTab.key === 'accrue_history'">

          <div v-if="Object.keys(detailsData.accruals).length">
              <div v-for="field in Object.keys(detailsData.accruals)" :key="field + userId + 'accruals'" class="mt-3">
                <div class="sub-title">{{ field.replaceAll('_', ' ') }}</div>
                <NestedTable :items="detailsData.accruals[field]" :fields="accrualsCols" :slots="accrualsSlots">
                  <template v-slot:updated_at="slotProps">
                    <div>{{ moment(slotProps.item.updated_at).format('DD/MM/YYYY') }}</div>
                  </template>

                  <template v-slot:accrue="slotProps">
                    <div :style="`color: ${slotProps.item.accrue < 0 ? '#DC3545' : '#3FA52F'}`">
                      {{ slotProps.item.accrue > 0 ? `+${slotProps.item.accrue}` : slotProps.item.accrue }}
                    </div>
                  </template>
                </NestedTable>
              </div>
          </div>
          <div v-else class="p-3">No data</div>
        </div>
      </template>
    </FullscreenTabs>
  </div>
  <div v-else class="p-3">No data</div>
</template>

<script>
import FullscreenTabs from '@components/Fullscreen/FullscreenTabs'
import NestedTable from '@tables/NestedTable'
import moment from 'moment'
import { mapGetters } from 'vuex'

export default {
  name: 'TimeOffReportDetailsRow',
  components: {
    FullscreenTabs,
    NestedTable
  },
  props: {
    userId: {
      type: Number
    },
    slotProps: {
      type: Object
    },
    detailsData: {
      type: Object
    },
    rowData: {
      type: Object
    },
    selectedYear: {
      type: Number
    },
    showModalOnInit: {
      type: Boolean,
      default: false
    }
  },
  emits: ['dataUpdated', 'showAdjustModal'],
  data () {
    return {
      moment,
      tabs: [
        { key: 'adjustments_history', name: 'Time off adjustments history' },
        { key: 'accrue_history', name: 'Accrue history' }
      ],
      currentTab: { key: 'adjustments_history', name: 'Time off adjustments history' },
      adjustmentsCols: [
        {
          key: 'updated_at',
          label: 'updated at',
          class: 'updated-nested-column'

        },
        {
          key: 'adjust',
          label: 'Adjust',
          class: 'adjust-column'
        },
        {
          key: 'description',
          label: 'Description',
          class: 'description-nested-column'
        }
      ],
      adjustmentsSlots: {
        updated_at: {
          name: 'updated_at',
          class: 'updated-nested-column'
        },
        adjust: {
          name: 'adjust',
          class: 'adjust-column'
        }
      },
      accrualsCols: [
        {
          key: 'updated_at',
          label: 'updated at',
          class: 'updated-nested-column'
        },
        {
          key: 'accrue',
          label: 'accrue',
          class: 'adjust-column'
        },
        {
          key: 'description',
          label: 'Description',
          class: 'description-nested-column'
        }
      ],
      accrualsSlots: {
        updated_at: {
          name: 'updated_at',
          class: 'updated-nested-column'
        },
        accrue: {
          name: 'accrue',
          class: 'adjust-column'
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      timeOffsSettings: 'timeOffsSettings/getTimeOffsSettings'
    })
  },
  mounted () {
    this.init()
    if (this.showModalOnInit) {
      this.$emit('showAdjustModal', this.userId)
    }
  },
  methods: {
    init () {
      // Initialize any needed data for the component
    },
    setCurrentTab (tab) {
      this.currentTab = tab
    }
  }
}
</script>

<style lang="scss" scoped>
.time-off-report-details {
  padding-left: 0px;
}

.time-off-report-details ::v-deep .fullscreen-tabs-controls {
  border-bottom: none;
  padding: 0 0 0 8px;
}

.time-off-report-details ::v-deep .table-controls-right__item {
  margin-right: 0 !important;
}

.time-off-report-details ::v-deep .table-controls-right__item:empty {
  display: none;
}

.table-tab-list {
  display: flex;
  flex: 1;
}

.table-tab-item {
  margin-right: 0;
  border-bottom: 2px solid $tableBorderColor;
  background: transparent;
  border-top: none;
  border-right: none;
  border-left: none;
  font-size: 15px;
  font-weight: 400;
  line-height: 16px;
  color: $body-color;
  padding: 7px 0;
  min-width: fit-content;
  box-sizing: border-box;

  /* Prevent width changes when font-weight changes */
  &::before {
    content: attr(data-text);
    font-weight: 500;
    height: 0;
    overflow: hidden;
    visibility: hidden;
    display: block;
  }

  &.active {
    font-weight: 500;
    border-color: $buttonTxtColor1;
    color: $buttonTxtColor1;
  }

  &_gap {
    width: 16px;
    display: inline-block;
    border-bottom: 2px solid $tableBorderColor;
  }

  &:last-child {
    flex: 1;
  }
}

.sub-title {
  color: $body-color;
  font-size: 14px;
  font-weight: 500;
  line-height: 30px;
  margin-bottom: 5px;
}

::v-deep  .updated-nested-column {
  min-width: 152px !important;
}
::v-deep  .adjust-column {
  min-width: 69px !important;
  padding-right: 80px !important;
  text-align: right;
}
::v-deep .fullscreen-tabs-controls, ::v-deep .fullscreen-tabs-controls-left {
  flex: 1;
}
::v-deep .fullscreen-tabs-controls {
  position: relative;
  padding-top: 10px !important;
}

::v-deep .nested-table > table tbody tr {
    border-bottom: unset !important;
}

.add-adjustments-btn {
  position: absolute;
  right: 0;
  top: 0;
}
</style>
